/**
 * Ajax (load more / filtering)
 *
 * @uses axios
 */

function find_ancestor (el, sel) {
  while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el,sel)));
  return el;
}

function get_parameter_by_name(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/**
 * @see https://stackoverflow.com/a/6021027
 */
function update_query_string_parameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  }
  else {
    return uri + separator + key + "=" + value;
  }
}

var fetching = false;

/**
 * Get results with ajax
 *
 * @param args
 *  args.request the request info
 *  ↳ args.request.url the target url
 *  ↳ args.request.type the type of request ('pagination'/'filter')
 *  ↳ args.request.parameter the parameter name
 *  args.container the container
 *  args.grid the item container
 *  args.target the button/link that was pressed
 */
var ajax_query_results = function(args) {

  var url       = args.request.url;
  var container = args.container;
  var grid      = args.grid;
  var button    = args.target;

  // prevent simultation requests
  if (fetching === false && typeof axios !== 'undefined') {
    fetching = true;

    // set ajax "state"
    container.classList.add('state--loading');
    if (args.request.type == 'filter') {
      container.classList.add('state--loading-big');
    }

    // remove focus
    document.activeElement.blur();

    axios.get(url)
      .then(function (response) {

        /**
         * Parse response into HTML DOM
         */
        var parser = new DOMParser();
        var html = parser.parseFromString(response.data, "text/html");

        /**
         * Set document title and history
         */
         if (window.history.pushState) {

            document.title = html.title;
            var new_url = args.request.url;

            if (args.request.type == 'pagination') {

              var current_url = window.location.href;

              // remove hash
              current_url = current_url.replace(location.hash,"");

              var load_arg = get_parameter_by_name(args.request.parameter);
              if (typeof load_arg == 'object') {
                load_arg = 1;
              }
              var next_page_nmb = parseInt(load_arg) + 1;

              var new_url = update_query_string_parameter(current_url, args.request.parameter, next_page_nmb);
            }

            window.history.pushState(new_url, html.title, new_url);

          }

        /**
         * Grid
         */
        var new_grid = html.querySelector('#' + container.id + ' .js-grid');
        if (new_grid && container) {

          // add entrance effect
          var items = new_grid.childNodes;

          for (var i = 0; i < items.length; i++) {
            if (typeof items[i].classList !== 'undefined') {
              items[i].classList.add('animation--entrance');
            }
          }
          if (args.request.type == 'pagination') {
            grid.innerHTML += new_grid.innerHTML;
          } else {
            grid.classList.add('animation--entrance');
            grid.innerHTML = new_grid.innerHTML;
          }

        }

        /**
         * Button
         */
        if (args.request.type == 'pagination') {
          // replace existing button
          var new_button = html.querySelector('#' + container.id + ' .js-load-more');
          if (new_button && button) {
            button.href = new_button.href;
          } else {
            container.classList.add('state--no-more-results');
          }
        } else {
          // inject whole new button

          // set active state
          var current_filter = container.querySelector('.filter--active');
          if (current_filter) {
            current_filter.classList.remove('filter--active');
          }
          if (args.target) {
            args.target.classList.add('filter--active');
          }

          // remove existing button
          var existing_button = document.querySelector('#' + container.id + ' .js-load-more-container');
          if (existing_button) {
            existing_button.remove();
          }

          // search and inject new
          var injectable_button = html.querySelector('#' + container.id + ' .js-load-more-container');
          if (injectable_button) {
            container.innerHTML += injectable_button.outerHTML;
          }

        }

        // Remove ajax "state"
        container.classList.remove('state--loading');
        if (args.request.type == 'filter') {
          container.classList.remove('state--loading-big');
        }

        /**
         * Animation time
         */
        setTimeout(function(){
          var animation_items = document.querySelectorAll('.animation--entrance');
          if (animation_items.length) {
            for (var i = animation_items.length - 1; i >= 0; i--) {
              if (typeof animation_items[i].classList !== 'undefined') {
                animation_items[i].classList.remove('animation--entrance');
              }
            }
          }
        }, 250);

      })
      .catch(function (error) {
        console.log(error);
      });

  }
  fetching = false;

}

 // Listen for clicks for load more links
document.addEventListener('click', function (e) {
  if (typeof e.target.classList !== 'undefined' && (e.target.classList.contains('js-load-more') || e.target.classList.contains('js-filter'))) {

    // stop whatever is happening
    e.preventDefault();

    var args = {};
    args.request = {};

    // ajax url
    args.request.url = e.target.href;

    // load parameter
    args.request.parameter = '';

    // target
    args.target = e.target;

    if (e.target.classList.contains('js-load-more')) {
      args.request.parameter = e.target.getAttribute('data-load');
      args.request.type = 'pagination';
    } else if (e.target.classList.contains('js-filter')) {
      args.request.parameter = e.target.getAttribute('data-filter');
      args.request.type = 'filter';
    }

    // ajax container
    args.container = find_ancestor(e.target, '.js-grid-container');

    if (args.container && args.request.parameter) {

      args.grid = args.container.querySelector('.js-grid');

      if (args.grid && args.request.url && typeof args.grid.id !== 'undefined') {
        ajax_query_results(args);
      }

    }

  }
});
